import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    paper: {
      display: 'inline-flex',
      flexDirection: 'column',
      width: 'auto',
    },
    editCell: {
      padding: 0,
    },
    field: {
      width: theme.spacing(6),
      '& .MuiInputBase-input': {
        padding: theme.spacing(0.5, 1.75),
      },
    },
    table: {
      '& .MuiTableCell-root': {
        borderBottomColor: 'transparent',
      },
    },
  };
};
